/* Canonical global mask sizing. Build copies this exact file into the account service. */
(function (scope) {
  'use strict';
  const version = 'size-rules/1.0.0';
  const engine = 'face-fit-engine/1.0.0';
  function sizeFor(cm) {
    if (typeof cm !== 'number' || !Number.isFinite(cm) || cm < 12 || cm > 17) return null;
    return cm < 13 ? 'S' : cm < 14 ? 'M' : cm < 15 ? 'L' : cm < 16 ? 'XL' : 'XXL';
  }
  function valid(record) {
    return !!record && record.schema === 1 && record.rules === version && record.engine === engine &&
      record.method === 'camera' && !!sizeFor(record.cm) && Number.isFinite(Date.parse(record.measuredAt));
  }
  function text(record) { return `${record.cm.toFixed(1)} cm / ${(record.cm / 2.54).toFixed(2)} in - ${sizeFor(record.cm)}`; }
  // Optional diagnostics belong to the completed result, not today's device/session.
  // Missing or invalid legacy diagnostics must never block sizing or checkout.
  function normalizeScanStats(value, completed = true) {
    if (!value || value.schema !== 1 || !Number.isSafeInteger(value.attempts) || value.attempts < 1 ||
      !Number.isSafeInteger(value.retries) || value.retries !== value.attempts - 1 ||
      !Number.isSafeInteger(value.failed) || value.failed < 0 || value.failed > value.attempts || (completed && value.failed === value.attempts)) return null;
    return {schema:1, attempts:value.attempts, retries:value.retries, failed:value.failed};
  }
  const scanStatsKeys = Object.freeze(['_Face Fit Attempts', '_Face Fit Retries', '_Face Fit Failed Attempts']);
  function scanStatsProperties(value, completed = true) {
    const stats = normalizeScanStats(value, completed);
    return stats ? Object.fromEntries(scanStatsKeys.map((key, i) => [key, String([stats.attempts, stats.retries, stats.failed][i])])) : {};
  }
  function stable(values) {
    if (values.length < 60 || values.some(v => !Number.isFinite(v))) return null;
    const sorted = [...values].sort((a,b) => a-b);
    const middle = Math.floor(sorted.length / 2);
    const cm = sorted.length % 2 ? sorted[middle] : (sorted[middle-1] + sorted[middle]) / 2;
    // Reject visibly unstable captures. This checks repeatability, not physical accuracy.
    if (sorted[Math.floor((sorted.length-1)*.9)] - sorted[Math.floor((sorted.length-1)*.1)] > .6 || !sizeFor(cm)) return null;
    return cm;
  }
  scope.SpaceArmoryFitRules = Object.freeze({version, engine, sizeFor, valid, text, stable, normalizeScanStats, scanStatsKeys, scanStatsProperties});
})(globalThis);
